/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsIn {
  /**
   * Is the property in the object.
   *
   * @public
   * @function f1.is.in
   * @param property the property name to look for
   * @param u the object to look inside of
   * @example
   *
   * ```ts
   * f1.is.in('x', { x: 1 }) => true
   * f1.is.in('x', { y: 1 }) => false
   * ```
   */
  <U extends {}, P extends PropertyKey>(property: P, u: U): u is U & Record<P, unknown>;
  /**
   * @param property the property name to look for
   */
  <U extends {}, P extends PropertyKey>(property: P): (u: U) => u is U & Record<P, unknown>;
}

/**
 * @see IsIn
 */
export default <U extends {}, P extends PropertyKey>(property: P, u: U): u is U & Record<P, unknown> => {
  return u != null && property in Object(u);
};
